/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StorefrontPlatformType } from './StorefrontPlatformType';
import {
    StorefrontPlatformTypeFromJSON,
    StorefrontPlatformTypeFromJSONTyped,
    StorefrontPlatformTypeToJSON,
    StorefrontPlatformTypeToJSONTyped,
} from './StorefrontPlatformType';
import type { StorefrontAddedBy } from './StorefrontAddedBy';
import {
    StorefrontAddedByFromJSON,
    StorefrontAddedByFromJSONTyped,
    StorefrontAddedByToJSON,
    StorefrontAddedByToJSONTyped,
} from './StorefrontAddedBy';

/**
 * A creator's external storefront link surfaced on the Drop page (Streamlabs Merch, Shopify, Fourthwall, etc.). MVP is a discoverable link card — catalog sync + checkout-on-rails come later. Response shape — includes `_id` assigned by Mongo. Use `DropStorefrontInput` for write bodies.
 * @export
 * @interface DropStorefront
 */
export interface DropStorefront {
    /**
     * 
     * @type {string}
     * @memberof DropStorefront
     */
    _id?: string;
    /**
     * 
     * @type {StorefrontPlatformType}
     * @memberof DropStorefront
     */
    type?: StorefrontPlatformType;
    /**
     * Public storefront URL the user is sent to.
     * @type {string}
     * @memberof DropStorefront
     */
    url?: string;
    /**
     * Username / handle extracted from the URL (e.g. `teepee` for `streamlabs.com/teepee/merch`). Optional for `OTHER`.
     * @type {string}
     * @memberof DropStorefront
     */
    username?: string;
    /**
     * The profile page where the parser found this link (e.g. the creator's Twitch profile URL). Parser-only — admin write bodies cannot supply this value (it would be attacker-controlled echo).
     * @type {string}
     * @memberof DropStorefront
     */
    detectedFromUrl?: string;
    /**
     * Unix-ms timestamp the link was first detected / added.
     * @type {number}
     * @memberof DropStorefront
     */
    detectedAt?: number;
    /**
     * 
     * @type {StorefrontAddedBy}
     * @memberof DropStorefront
     */
    addedBy?: StorefrontAddedBy;
}



/**
 * Check if a given object implements the DropStorefront interface.
 */
export function instanceOfDropStorefront(value: object): value is DropStorefront {
    return true;
}

export function DropStorefrontFromJSON(json: any): DropStorefront {
    return DropStorefrontFromJSONTyped(json, false);
}

export function DropStorefrontFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropStorefront {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'type': json['type'] == null ? undefined : StorefrontPlatformTypeFromJSON(json['type']),
        'url': json['url'] == null ? undefined : json['url'],
        'username': json['username'] == null ? undefined : json['username'],
        'detectedFromUrl': json['detectedFromUrl'] == null ? undefined : json['detectedFromUrl'],
        'detectedAt': json['detectedAt'] == null ? undefined : json['detectedAt'],
        'addedBy': json['addedBy'] == null ? undefined : StorefrontAddedByFromJSON(json['addedBy']),
    };
}

export function DropStorefrontToJSON(json: any): DropStorefront {
    return DropStorefrontToJSONTyped(json, false);
}

export function DropStorefrontToJSONTyped(value?: DropStorefront | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'type': StorefrontPlatformTypeToJSON(value['type']),
        'url': value['url'],
        'username': value['username'],
        'detectedFromUrl': value['detectedFromUrl'],
        'detectedAt': value['detectedAt'],
        'addedBy': StorefrontAddedByToJSON(value['addedBy']),
    };
}

